export default __webpack_public_path__ + "static/media/logo_craques_enem.d08109fa.png";